export const DRAWER_WIDTH = 240;
export const ELLIPS_LENGTH = 18;
